import { EstadoSinPermiso } from '../../../componentes/EstadoPagina';
import { rolesDe } from '../../../logica/acceso';
import { usePermisos } from '../../../permisos/permisos';
import type { PropsPantalla } from '../../tipos';
import { useContextoReservas } from '../contexto';
import { PERMISOS } from '../textos';
import { Estancias } from './Estancias';
import '../reservas.css';

/**
 * «Estancias» (Operativa, entrada propia `estancias`, G878, ADR-0224): la pantalla 8.9 con su icono en el menú, ya no
 * como apartado de Reservas. El servidor solo la manda con `reservas.reservas.ver` y el bloque `estancias` (o al
 * Propietario con «+», que lleva a contratarlo).
 */
export function PantallaEstancias(props: PropsPantalla) {
    const { ops, negocio, membresia, nombreNegocio, navegar, movil } = props;
    const { puede } = usePermisos();
    const contexto = useContextoReservas(ops, negocio, membresia, nombreNegocio);
    if (!puede(PERMISOS.ver)) {
        return <EstadoSinPermiso seccion="Estancias" rol={membresia === undefined ? '' : rolesDe(membresia)} negocio={nombreNegocio} onInicio={() => { navegar('/'); }} movil={movil} />;
    }
    return (
        <div className="rv-rs-pantalla">
            <Estancias {...props} contexto={contexto} />
        </div>
    );
}
